export default __webpack_public_path__ + "static/media/gallery-wip-neck-base_01.552ab0af.jpg";